export default "__VITE_ASSET__C1_VqgUo__"